module.exports = __webpack_public_path__ + "assets/img/homeAboutImg.c89c980a.jpg";